export function removeUnderscore(str) {
  return str.replace(/_/g, " ");
}
